const translations = {
  "en": {
    "Binding failed: %{var0}": "Binding failed: %{var0}",
    "Binding successful": "Binding successful",
    "Portfolio shows your investment accounts only": "Portfolio shows your investment accounts only"
  },
  "zh-tw": {
    "Binding failed: %{var0}": "綁定失敗：%{var0}",
    "Binding successful": "綁定成功",
    "Portfolio shows your investment accounts only": "投資組合僅顯示你的投資帳戶。"
  }
};

export default translations;
